(function (angular) {
  var dynamicCtrl = function ($scope, $translate, RouteConfig, $routeParams, Api, $location, ReqAndUpload, $q, $http, NgTableParams, ROLES, formNotify) {
    if (window.location.href.indexOf('write.app') > 0) {
      $routeParams.module = 'content';
      $routeParams.page = 'articles-new';
      if ($location.search() && $location.search().user) $routeParams.user = $location.search().user;
      if ($location.search() && $location.search().group) $routeParams.group = $location.search().group;
      $routeParams.type = $location.path().indexOf('/') === -1 ? 'post' : $location.path().replace('/', '');
    }

    var route = `${$routeParams.module}/${$routeParams.page}`;
    if ($routeParams.id) route += '-detail';
    var config = RouteConfig.hasOwnProperty(route) ? RouteConfig[route] : false;

    $scope.params = $routeParams;

    $scope.ROLES = ROLES;

    if (config) {
      var prevUrl = $routeParams.id ? `/manage.app#!/${$routeParams.module}/${$routeParams.page}` : false;
      $scope.change_title($scope.header_title, prevUrl);

      // Create var for id route parameter
      if ($routeParams.id) $scope.id = $routeParams.id;

      // Register a delete fuction
      $scope.delete = function (query) {
        if (query.indexOf('/id') > 0) query = query.replace(/\/id/, `/${$routeParams.id}`);
        Api.delete(query, function (err, ret) {
          if ($scope.hasOwnProperty(ret.response))
            App.toast(TXT[data.response], 3000);
          if (!err) $location.path(`${$routeParams.module}/${$routeParams.page}`);
        });
      }

      // Register a loadData function, handle retriving lists or entities data
      $scope.loadData = function (query, target) {
        var responseSchema = arguments[2] || 'response';
        var callback = arguments[3] || false;
        if (query.indexOf('/id') > 0) query = query.replace(/\/id/, `/${$routeParams.id}`);
        Api.get(query, function (err, ret) {
          if (!err) {
            if (responseSchema.indexOf('.') === -1) {
              $scope[target] = ret[responseSchema];
            } else {
              var nodes = responseSchema.split('.');
              $scope[target] = ret[nodes[0]][nodes[1]];
            }
            if (callback) callback();
          }
        });
      }

      // Register save function, handle all types of data validation and calls Api
      $scope.save = function (payload, query, Form) {
        if (payload.domain) {
          payload.domain = payload.domain.toLowerCase();
        }
        var autoSave = payload.autoSave ? true : false;
        delete payload.autoSave;
        const digest = payload.digest || false;
        delete payload.digest;
        if (Form.$invalid || Form.submiting) {
          formNotify($scope, Form);
          return false;
        }
        Form.submiting = true;
        var method = (arguments[3] || 'PUT').toLowerCase();
        var callback = arguments[4] || false;
        var dataHandle = arguments[5] || false;
        var callbackError = arguments[6] || false;

        // Handle data before api call
        if (dataHandle) {
          var respHandle = dataHandle(payload);
          if (respHandle === 'ERROR') {
            Form.submiting = false;
            return false;
          }
        }

        // Bugfix, remove _id from payload
        delete payload._id;

        var upload = function (field) {
          var deferred = $q.defer();
          var path = query.indexOf('user/') === 0 ? 'user' : 'project';
          ReqAndUpload.upload(payload[field], path).then(function (filename) {
            payload[field] = filename;
            deferred.resolve(true);
          });
          return deferred.promise;
        }


        // Checking for field types for proper handling
        var promises = [];
        for (let field in payload) {
          if (payload[field] instanceof String) continue;
          if (payload[field] instanceof Number) continue;
          if (payload[field] instanceof Boolean) continue;
          if (payload[field] instanceof Array) continue;
          if (payload[field] instanceof Object && !payload[field] instanceof File) continue;
          if (payload[field] instanceof File || (payload[field] instanceof Object && payload[field].hasOwnProperty('$ngfBlobUrl'))) {
            var uploadRequest = upload(field);
            promises.push(uploadRequest);
          }
          ;
        }

        $q.all(promises).then(function () {
          if (query.indexOf('/id') > 0) query = query.replace(/\/id/, `/${$routeParams.id}`);
          Api[method](query, payload, function (err, ret) {
            Form.submiting = false;
            var message = 'MESSAGES.OK_DEFAULT';
            if (autoSave) {
              message = 'MESSAGES.OK_AUTOSAVE';
            }
            if (ret.response === 'ARTICLE_CREATED') {
              if (!err && callback) {
                return callback(ret);
              }
            }
            if (ret.response === 'ARTICLE_SCHEDULED') {
              message = 'MESSAGES.OK_SCHEDULED';
            }

            if (ret.response === 'PROJECT_GENERAL_DATA_UPDATED_ALTER_LANGUAGE') {
              message = 'MESSAGES.PROJECT_GENERAL_DATA_UPDATED';

              location.href = location.origin + "/purgeall";

              $translate('MESSAGES.RELOAD_THIS_PAGE').then(function (result) {
                App.toast(result, 3000);
              });

              setTimeout(() => {
                location.reload();
              }, 3000);
            }

            if (err && callbackError) {
              callbackError(err, ret);
              return;
            }

            if (digest) {
              Api.put('project/digest', digest, function (err, ret) {
                $translate(message).then(function (result) {
                  App.toast(result, 3000);
                });
              });
            } else {
              $translate(message).then(function (result) {
                App.toast(result, 3000);
              });
            }


            if (!err && callback) callback(ret);

            if (err) {
              throw err;
            }
          });
        })

      }

      // Use input checkbox for one array
      $scope.checkboxArray = function (checked, value, array) {
        if (!checked && array.indexOf(value) === -1) array.push(value);
        if (checked && array.indexOf(value) !== -1) array.splice(array.indexOf(value), 1);
      }

      // Initialize Materialize libs for new DOM elements
      $('select:not(.ng-material)').material_select();
      $('textarea[length]').characterCounter();
      if ($('ul.tabs').length > 0) {
        $('ul.tabs').tabs();
      }

      // side nav tools editor
      $('#editor-tools .side-tools').on('click', function () {
        $('#editor-tools').toggleClass('hide-nav show-nav');
        return false;
      });

      // Call a custom controller when necessary
      if (
        config.hasOwnProperty('controller') &&
        window.hasOwnProperty(`${$routeParams.module}Ctrl`) &&
        window[`${$routeParams.module}Ctrl`].hasOwnProperty(config.controller)) {
        window[`${$routeParams.module}Ctrl`][config.controller]($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify);
      }

      // Navigate to a view
      $scope.goTo = function (path) {
        window.location.href = `/manage.app#!/${path}`;
        // console.log(`/manage.app#!/${path}`);
      }
    }
  }
  dynamicCtrl.$inject = ['$scope', '$translate', 'RouteConfig', '$routeParams', 'Api', '$location', 'ReqAndUpload', '$q', '$http', 'NgTableParams', 'ROLES', 'formNotify'];

  angular.module('app.full')
    .directive('beraNumbersOnly', function () {
      return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
          function fromUser(text) {
            if (text) {
              var transformedInput = text.replace(/[^0-9]/g, '');

              if (transformedInput !== text) {
                ngModelCtrl.$setViewValue(transformedInput);
                ngModelCtrl.$render();
              }
              return transformedInput;
            }
            return undefined;
          }

          ngModelCtrl.$parsers.push(fromUser);
        }
      };
    })
    .controller('DynamicCtrl', dynamicCtrl);

})(angular);
